/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
// import { useState } from "react";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";

// Material Kit 2 React examples
import DefaultNavbar from "bachrosenComponents/bachNavbar";
import CenteredFooter from "bachrosenComponents/centeredFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/home1.jpg";
import { useState } from "react";

function ContactSite() {
  const [firstname, setFirstName] = useState("");
  const [surname, setSurName] = useState("");
  const [comment, setComment] = useState("");
  const [userMail, setUserMail] = useState("");

  //SMTP.JS, ElasticEmail, EmailJS
  const sendEmail = (event) => {
    event.preventDefault();
    window.Email.send({
      Host: "smtp.ionos.de",
      Username: "info@bachrose-bietingen.de",
      Password: "PASSWORT",
      To: ["bachrose.bietingen@gmail.com", userMail],
      From: "info@bachrose-bietingen.de",
      Subject: "Test E-Mail - Anmeldung Freundschaftstreffen 2024",
      Body: `<strong>Anmeldung erfolgreich angekommen</strong><br />
        Name: ${firstname} ${surname}<br />
        E-Mail: ${userMail}<br />
        Kommentar: ${comment}`,
    }).then(() =>
      alert(
        "Diese Funktion wird gerade gewartet. Bitte über die E-Mail im Impressum Kontakt aufnehmen."
      )
    );
    // }).then(() => alert("Anfrage gesendet. Sie sollten eine Infomail erhalten."));
  };

  return (
    <>
      <MKBox position="fixed" top="0.5rem" width="100%">
        <DefaultNavbar routes={routes} dark info center />
      </MKBox>
      <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <MKTypography
          align="center"
          variant="h1"
          color="white"
          sx={({ breakpoints, typography: { size } }) => ({
            [breakpoints.down("md")]: {
              fontSize: size["3xl"],
            },
          })}
        >
          Kontakt
        </MKTypography>
      </MKBox>

      <Card
        sx={{
          // p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <MKBox component="section" py={12}>
          <Container>
            <Grid
              container
              item
              justifyContent="center"
              xs={10}
              lg={7}
              mx="auto"
              textAlign="center"
            >
              <MKTypography variant="h3" mb={1}>
                Schreib uns einfach an :)
              </MKTypography>
            </Grid>
            <Grid container item xs={12} lg={7} sx={{ mx: "auto" }}>
              <MKBox width="100%" component="form" method="post" autocomplete="off">
                <MKBox p={3}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <MKInput
                        variant="standard"
                        label="Vorname"
                        fullWidth
                        value={firstname}
                        onChange={(e) => setFirstName(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <MKInput
                        variant="standard"
                        label="Nachname"
                        fullWidth
                        value={surname}
                        onChange={(e) => setSurName(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <MKInput
                        variant="standard"
                        type="email"
                        label="Email"
                        fullWidth
                        value={userMail}
                        onChange={(e) => setUserMail(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <MKInput
                        variant="standard"
                        label="Beschreibung"
                        multiline
                        fullWidth
                        rows={6}
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                      />
                    </Grid>
                    {/* <Grid item xs={12} alignItems="center" ml={-1}>
                      <Switch checked={checked} onChange={handleChecked} />
                      <MKTypography
                        variant="button"
                        fontWeight="regular"
                        color="text"
                        ml={-1}
                        sx={{ cursor: "pointer", userSelect: "none" }}
                        onClick={handleChecked}
                      >
                        &nbsp;&nbsp;I agree the&nbsp;
                      </MKTypography>
                      <MKTypography
                        component="a"
                        href="#"
                        variant="button"
                        fontWeight="regular"
                        color="dark"
                      >
                        Terms and Conditions
                      </MKTypography>
                    </Grid> */}
                  </Grid>
                  <Grid container item justifyContent="center" xs={12} my={2}>
                    <MKButton
                      type="submit"
                      variant="gradient"
                      color="dark"
                      fullWidth
                      onClick={sendEmail}
                      // onClick={() => sendEmail({ firstname })}
                    >
                      E-Mail Abschicken
                    </MKButton>
                  </Grid>
                </MKBox>
              </MKBox>
            </Grid>
          </Container>
        </MKBox>
      </Card>
      <MKBox px={1} mt={6}>
        <CenteredFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default ContactSite;
